<template>
<div class="chapter">
<div class="inner_page">
<h1>Content</h1>
<ol>
<li><a href="#/Text/Section0003">Six Frightened Men</a></li>
<li><span href="#/Text/Section0004" title="Link target outside of Sample">Prisoner of War</span></li>
<li><span href="#/Text/Section0005" title="Link target outside of Sample">Satellite of Death</span></li>
<li><span href="#/Text/Section0006" title="Link target outside of Sample">The Mannion Court-Martial</span></li>
<li><span href="#/Text/Section0007" title="Link target outside of Sample">Skid Row Pilot</span></li>
<li><span href="#/Text/Section0008" title="Link target outside of Sample">Kill Me If You Can!</span></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?3e200c28